module.exports = __webpack_public_path__ + "img/activ.7ddc0991.svg";